import { gql } from '@apollo/client';

export default gql`
  query ProducerByIdQuery($id: Int!) {
    producer: producerById(id: $id) {
      id
      name
      allowBehavioralQuestions
      defaultTimezone
    }
  }
`;
